module.exports = __webpack_public_path__ + "img/pic3.0b30da47.png";